export const saveOrganization = (organization: string): void => {
  localStorage.setItem('organization', organization);
};
export const getOrganization = (): string | undefined => {
  const processStateParam = (stateParam: string | null): string => {
    if (!stateParam) return '';
    try {
      if (stateParam.includes('=')) {
        return stateParam.split('=')[1];
      }
      const firstDecode = decodeURIComponent(stateParam);
      const secondDecode = decodeURIComponent(firstDecode);
      const parsedState = JSON.parse(secondDecode);
      return parsedState.fqdn || '';
    } catch (error) {
      console.error('Error processing stateParam:', error);
      return '';
    }
  };

  if (!process.env.REACT_APP_LOCAL) {
    const newlink = window.location.href.split('.co/')[1]
      ? window.location.href.split('.co/')[1]
      : window.location.href.split('.')[0];
    let splitlink: string | string[] = newlink.split('/') ? newlink.split('/') : '';
    const queryParams = new URLSearchParams(window.location.search);
    const stateParam = queryParams.get('state');
    const fqdn = processStateParam(stateParam);
    const FQDN = localStorage.getItem('FQDN');
    if (FQDN) {
      return (splitlink = FQDN);
    } else if (fqdn === '') {
      return (splitlink = splitlink[0]);
    }
    return (splitlink = fqdn);
  }
  const queryParams = new URLSearchParams(window.location.search);
  const stateParam = queryParams.get('state');
  const fqdn = processStateParam(stateParam);
  const microclientPart = fqdn;
  let pathSegments;
  if (fqdn === '') {
    pathSegments = window.location.pathname.split('/');
    const microclientPart = pathSegments[1];
    return microclientPart;
  }
  return microclientPart;
};

export const removeOrganization = (): void => localStorage.removeItem('organization');

export const handleCompanyUrl = (path: string): string => {
  return `${path}`;
};

export const handleOrganizationUrl = (organization: string, path: string): string => {
  return `/${organization}${path}`;
};
